import type { OptionalSelectionModifiers } from '@/atoms'
import type Feature from 'ol/Feature'
import type Geometry from 'ol/geom/Geometry'

import { getCrudSelection, setCrudSelection, getMainSelection, setMainSelection } from '@/atoms'

import { getConnectedList } from '../../../../atoms/selection/read/getConnectedList'
import { getMapSelectionContext } from '../../../../atoms/selection/read/getMapSelectionContext'

export function clickDepot(feature: Feature<Geometry>, modifiers: OptionalSelectionModifiers) {
  const connectedList = getConnectedList()
  const mapSelectionContext = getMapSelectionContext()

  const depotId = feature.getId()?.toString()

  if (depotId) {
    const selection = [depotId]

    // select
    if (mapSelectionContext.type === 'crud') {
      if (mapSelectionContext.category === 'depots') {
        const crudSelection = getCrudSelection()
        const withoutModifiers = Object.keys(modifiers).every(key => modifiers[key] === false)

        // If there's no modifier and the depot is already selected we must deselect it
        if (withoutModifiers) {
          const index = crudSelection.depots.indexOf(selection[0])

          if (index !== -1) {
            selection.splice(index, 1)

            setCrudSelection('depots', selection, { modifiers })
            return
          }
        }

        setCrudSelection('depots', selection, { modifiers })

        // try to scroll to
        if (
          connectedList.status === 'connected' &&
          connectedList.category === 'depots' &&
          !connectedList.disabled
        ) {
          connectedList.scrollTo(depotId)
        }
      }
    } else {
      const mainSelection = getMainSelection()
      const withoutModifiers = Object.keys(modifiers).every(key => modifiers[key] === false)

      // If there's no modifier and the depot is already selected we must deselect it
      if (withoutModifiers) {
        const index = mainSelection.depots.indexOf(selection[0])

        if (index !== -1) {
          selection.splice(index, 1)

          setMainSelection('depots', selection, { modifiers })
          return
        }
      }
      setMainSelection('depots', selection, { modifiers })
    }
  }
}
